import React, { FC } from 'react';

// TODO: Need fixed this.
// @ts-ignore
import { submit } from 'redux-form/immutable';
import {
  withReduxDialog,
  WithReduxDialogProps,
} from '@eGroupTeam/redux-modules/immutable/dialogs';

import Button from '@eGroupTeam/material/Button';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@eGroupTeam/material';
import { useDispatch } from 'react-redux';
import { OrganizationRole } from 'types';
import OrgRoleForm, { FORM } from './OrgRoleForm';

export const DIALOG = 'orgEditRoleDialog';

export interface OrgEditRoleDialogProps {
  onSubmit?: (values: any) => void;
  loading?: boolean;
  organizationRole?: OrganizationRole;
}

const OrgEditRoleDialog: FC<OrgEditRoleDialogProps & WithReduxDialogProps> = ({
  onSubmit,
  isOpen,
  handleClose,
  loading,
  organizationRole,
}) => {
  const dispatch = useDispatch();
  return (
    <Dialog open={isOpen} fullWidth onClose={handleClose}>
      <DialogTitle>編輯內容</DialogTitle>
      <DialogContent>
        <OrgRoleForm initialValues={organizationRole} onSubmit={onSubmit} />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>取消</Button>
        <Button
          loading={loading}
          variant="contained"
          color="primary"
          onClick={() => {
            dispatch(submit(FORM));
          }}
        >
          確認
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withReduxDialog(DIALOG)<HTMLDivElement, OrgEditRoleDialogProps>(
  OrgEditRoleDialog
);
